
<div *ngIf="loading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
 <div class="container-fluid mt-5">
    <div class="mb-3 text-end mt-2" style="padding-top: 2rem;">
      <button class="btn btn-success" (click)="openAddModal()">+ Add Question</button>
    </div>
  
    <div class="row">
      <div class="col-12 mb-3" *ngFor="let q of submittedQuestions; let i = index">
        <div class="card shadow-sm w-100">
          <div class="card-body">
            <h5 class="card-title">
              Q{{ i + 1 }}. {{ q.QuestionText }}
            </h5>
            <p class="card-text">
              <strong>Query:</strong> {{ q.Query }}
            </p>
            <p class="text-muted">
              <strong>Category:</strong> {{ getCategoryName(q.CategoryId) }}
            </p>
            <button class="btn btn-sm btn-primary" (click)="openEditModal(q)">
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Add/Edit Modal -->
  <div class="modal fade" id="editModal" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEditMode ? 'Edit Question' : 'Add Question' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label class="form-label">Question</label>
              <input type="text" class="form-control" [(ngModel)]="selectedQuestion.QuestionText" name="QuestionText" />
            </div>
            <div class="mb-3">
              <label class="form-label">Query</label>
              <input type="text" class="form-control" [(ngModel)]="selectedQuestion.Query" name="Query" />
            </div>
  
            <div class="mb-3">
              <label class="form-label">Answer</label>
              <div class="answer-editor">
                <div class="custom-quill-wrapper">
                  <quill-editor
                    [(ngModel)]="selectedQuestion.Answer"
                    name="answer"
                    format="text"
                    class="custom-quill">
                  </quill-editor>
                </div>
              </div>
              
            </div>
            <div class="mb-3">
              <label class="form-label">Category</label>
              <select class="form-select" [(ngModel)]="selectedQuestion.CategoryId" name="category">
                <option [ngValue]="null" disabled selected>Select Category</option>
                <option *ngFor="let c of categories" [value]="c.TWL_ID">
                  {{ c.TWL_NAME }}
                </option>
              </select>
            </div>
          </form>
        </div>
  
        <div class="modal-footer">
          <button 
          type="button" 
          class="btn btn-secondary" 
          data-bs-dismiss="modal"
          (click)="resetForm()">
          Cancel
        </button>
          <button type="button" class="btn btn-success" (click)="saveChanges()">
            {{ isEditMode ? 'Save' : 'Add' }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="loading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>